import { PermissionEnum } from '@sr-sdks/api-sdk-axios';
import { useParams } from 'react-router-dom';
import { FEATURE_FLAGS } from '../constant/featureFlags';
import AddTitleLink from './AddTitleLink';
import IfFeatureEnabledMSR3 from './IfFeatureEnabledMSR3';
import ProtectElement from './ProtectElement';
import SendInviteDialog from './SendInviteDialog';

const HomeActions = () => {
  const { workspaceId } = useParams();

  return (
    <>
      <IfFeatureEnabledMSR3
        name={FEATURE_FLAGS.MSR3_TITLE_PAGE_ROUTE}
        isEnabled="true"
      >
        {/* Same permission the /add-title route enforces, so a user without
            it is not offered a button that lands on Access Denied. */}
        <ProtectElement
          permissionRequired={[PermissionEnum.ViewTitles]}
          workspaceId={workspaceId}
        >
          <AddTitleLink />
        </ProtectElement>
      </IfFeatureEnabledMSR3>

      <SendInviteDialog heading="Invite Teammate" />
    </>
  );
};

export default HomeActions;
